import { RawAttachmentFile } from "ts/api/attachmentFile";

export const cutOffFileTitle = (file: RawAttachmentFile) =>
  file.title.length > 15
    ? { ...file, title: `${file.title.slice(0, 15)}...` }
    : file;
